<template>
  <v-expansion-panels flat v-if="isFolder" :accordion="true" :value="model.active ? 0 : null">
    <v-expansion-panel class="nt-tree-view-expand">
      <v-expansion-panel-header>
        <v-row dense>
          <v-col cols="12" class="font-weight-regular" v-if="model.nivelCurso">Conteúdo do curso</v-col>
          <v-col cols="12" class="font-weight-bold">{{ model.text }}</v-col>
          <v-col cols="12" class="text-caption pt-0">Concluído: {{ progressFormated }}%</v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content focusable>
        <item v-for="(data, index) in model.nodes" :key="index" :model="data"/>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
  <v-card flat v-else class="lesson-card">
    <v-card-text>
      <router-link class="accent--text" :to="{ name: 'salaDeAula.aula', params: { aulaId: model.id } }">
        <v-icon class="accent--text">{{ getIconByLessonType(model.type_lesson) }}</v-icon> {{ model.text }}
      </router-link>
      <v-progress-linear title="Progresso da aula" height="3" color="accent lighten-1" style="opacity: 0.7;" background-color="grey lighten-1"
                         :value="model.progress * 100"/>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'item',
  props: {
    model: Object
  },
  computed: {
    isFolder () {
      return this.model.nodes
    },
    progressFormated () {
      return (this.model.progress * 100).toFixed(0)
    }
  },
  methods: {
    getIconByLessonType (lessonType) {
      switch (lessonType) {
        case 'LV':
          return 'mdi-play'
        case 'LC':
          return 'mdi-book-open-variant'
        case 'LL':
          return 'mdi-format-list-bulleted'
      }
    }
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
}

.nt-tree-view-expand {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.lesson-card .v-card__text {
  padding: 8px !important;
}

.lesson-card .v-card__text > a {
  text-decoration: none;
  opacity: 0.7;
}

.lesson-card .v-card__text > a:hover, .lesson-card .v-card__text > a:hover i,
.lesson-card .v-card__text > a.router-link-active, .lesson-card .v-card__text > a.router-link-active i {
  opacity: 1;
}

.lesson-card .v-card__text > a.router-link-active {
  font-size: 16px;
}

.lesson-card .v-card__text > a.router-link-active i {
  font-size: 24px;
}

.lesson-card .v-card__text > a > i {
  font-size: 18px;
}

.lesson-card .progress-linear {
  margin: 2px 0 5px 0;
}
</style>
